export function LeaderboardSlide(tournamentCode, tournamentName, tournamentType) {
	this.element = null;
	this.parent = null;
	this.scoreCount = 0;
	this.intervalId = null;
	// Set by fitRows(): how many entries fit in the window on this screen, and
	// the height each row was stretched to so that they divide it exactly.
	this.showing = 0;
	this.rowHeight = 0;
	this.visible = false;
	this.tournamentCode = tournamentCode;
	this.tournamentName = tournamentName;
	this.tournamentType = tournamentType;
}
LeaderboardSlide.prototype.elementCreated = function(element) {
	this.element = element;
	this.parent = element.querySelector('.slide-content');

	var newTournamentName = this.tournamentName;
	if (this.tournamentName == 'Team One') {
		newTournamentName = element.getAttribute('data-flight-one-name');
	}
	if (this.tournamentName == 'Team Two') {
		newTournamentName = element.getAttribute('data-flight-two-name');
	}

	element.querySelector('.tournamentname').innerText = newTournamentName;
	if (this.tournamentType) {
		element.querySelector('.tournamenttype').innerText = this.tournamentType;
	}
};
LeaderboardSlide.prototype.prepare = function() {
	var self = this;
	var tournamentCode = this.tournamentCode;
	var xhr = new XMLHttpRequest();
	xhr.open('GET', '/api/scores/' + tournamentCode);
	xhr.onreadystatechange = function() {
		if (xhr.readyState === 4) {
			var response = JSON.parse(xhr.responseText);
			self.createLeaderboard(response.participants);
			self.scoreCount = response.participants.length;
		}
	};
	xhr.send(null);
};
LeaderboardSlide.prototype.show = function() {
	var self = this;
	// console.log('showing slide: ' + self.tournamentName);
	self.visible = true;
	// We can't get the height of the parent element until after it's
	// shown. So, we need a slight delay.
	setTimeout(function() {
		// How many entries fit is a property of the screen, not of the design,
		// so measure it. This used to be a hardcoded 6 rows and a hardcoded
		// 39.375vw of scroll, which only lined up on a 16:9 board -- everywhere
		// else the last row of each page ended up half-hidden behind the footer.
		self.fitRows();

		var timeout = 8000;
		var currentTop = 0;
		var currentSlide = 0;

		self.intervalId = setInterval(function() {
			var count = self.scoreCount;
			// If we don't have ANY items, we add one item for "No Scores Available"
			if (count === 0) {
				count = 1;
			}
			// Normally fitRows() has already succeeded in show(), above. It
			// can't have if prepare()'s request was slow enough that the table
			// only arrived after we did, so try again here rather than getting
			// stuck on this slide.
			var showing = self.showing || self.fitRows() || 1;
			var slides = Math.ceil(count / showing);
			var table = self.parent.querySelector('.leaderboard');

			currentSlide++;
			if (currentSlide >= slides && self.onTriggerNext) {
				self.onTriggerNext();
			}
			else if (table) {
				// A whole page of rows, which is the window height exactly, so
				// the next entry lands flush against the top of the window.
				currentTop += showing * self.rowHeight;
				table.style.webkitTransform = 'translate3d(0, -' + currentTop + 'px, 0)';
				table.style.transform = 'translate3d(0, -' + currentTop + 'px, 0)';
			}
		}, timeout);
	}, 20);
};
// Stretch the rows so that a whole number of them exactly fills the window
// between the header and the footer, and remember how many that is, so that
// scrolling by a page never leaves an entry sliced in half at the bottom.
//
// Rounding down is what keeps this safe: it always asks the rows to grow into
// the space left over, never to shrink, and a table row will refuse to be
// shorter than its own contents.
//
// Returns 0 when there is nothing to measure yet: prepare() builds the table
// from an XHR response, which can land after the slide is already on screen.
LeaderboardSlide.prototype.fitRows = function() {
	this.showing = 0;
	this.rowHeight = 0;

	var table = this.parent.querySelector('.leaderboard');
	var height = this.parent.clientHeight;
	if (!table || table.rows.length === 0 || height <= 0) {
		return 0;
	}

	// Measure what the stylesheet wants a row to be, not what we stretched it
	// to the last time this slide came around.
	//
	// offsetHeight rather than getBoundingClientRect(): we are called 20ms into
	// the slide-enter transition, which has the whole slide under a rotateX()
	// and a perspective(), and a transformed bounding box measures a row at a
	// fifth of its real height that early on. offsetHeight is layout space, so
	// the transition can't fool it. Averaging over the table also spreads out
	// the integer rounding offsetHeight does.
	this.setRowHeight(table, '');
	var natural = table.offsetHeight / table.rows.length;
	if (natural <= 0) {
		return 0;
	}

	this.showing = Math.max(1, Math.floor(height / natural));
	this.rowHeight = height / this.showing;
	this.setRowHeight(table, this.rowHeight + 'px');

	// A row won't go below the height of its own contents. If rounding left us
	// asking it to, drop an entry from the page rather than let the last row
	// spill past the bottom of the window.
	if (this.showing > 1 && table.offsetHeight / table.rows.length > this.rowHeight + 0.5) {
		this.showing--;
		this.rowHeight = height / this.showing;
		this.setRowHeight(table, this.rowHeight + 'px');
	}

	return this.showing;
};
// Set every row to a given height, or pass '' to hand them back to the
// stylesheet. The cells are vertical-align: middle by default, so the text
// inside stays centred as the row grows.
LeaderboardSlide.prototype.setRowHeight = function(table, height) {
	var rows = table.rows;
	for (var i = 0; i < rows.length; i++) {
		rows[i].style.height = height;
	}
};
LeaderboardSlide.prototype.hide = function() {
	this.visible = false;
	if (this.intervalId) {
		clearInterval(this.intervalId);
	}
};
LeaderboardSlide.prototype.createLeaderboard = function(scores) {
	while (this.parent.childNodes.length > 0) {
		this.parent.removeChild(this.parent.childNodes[0]);
	}

	var table = document.createElement('table');
	table.classList.add('leaderboard');
	scores.forEach(function(participant) {
		var tr = document.createElement('tr');
		table.appendChild(tr);

		var tdname = document.createElement('td');
		tdname.classList.add('name');
		tr.appendChild(tdname);
		var blockname = document.createElement('div');
		blockname.innerText = participant.name;
		tdname.appendChild(blockname);

		var tdscore = document.createElement('td');
		tdscore.classList.add('score');
		tr.appendChild(tdscore);
		var blockscore = document.createElement('div');
		var score = participant.score;
		if (score > 0) {
			score = "+" + score.toString();
		}
		else if (score === 0) {
			score = "E";
		}
		else {
			score = "\u2212" + Math.abs(score);
		}
		blockscore.innerText = score;
		tdscore.appendChild(blockscore);

		var tdthru = document.createElement('td');
		tdthru.classList.add('thru');
		tr.appendChild(tdthru);
		var blockthru = document.createElement('div');
		var partthru = participant.thru;
		var thru = (partthru === null)? "F*": participant.thru.toString();
		if (thru === "0") { thru = "\u2013"; }
		if (thru === "18") { thru = "F"; }
		blockthru.innerText = thru;
		tdthru.appendChild(blockthru);
	});

	// If there are no scores
	if (scores.length === 0) {
		var tr = document.createElement('tr');
		table.appendChild(tr);

		var tdmessage = document.createElement('td');
		tdmessage.classList.add('message');
		tdmessage.innerText = 'Scores are not currently available';
		tr.appendChild(tdmessage);
	}

	this.parent.appendChild(table);

	// prepare() normally runs while this slide is still off screen, where there
	// is no window height to measure against. If it was slow enough that we're
	// already showing, show() has been and gone without a table to fit, so do
	// it now.
	if (this.visible) {
		this.fitRows();
	}
};
